import type { ColumnVisibilityItem } from "providers/Auth";

type UnitsTableFeatures = {
  /** Home rent and Site rent (ManageAmerica or the home/site rent setting). */
  homeSiteRent: boolean;
  /** Source, for partners connected to a PMS. */
  isPMS: boolean;
  /** Allow applications and List unit, for BoomScreen partners. */
  isBoomScreen: boolean;
};

type AccountFlags = {
  isManageAmerica: boolean;
  isHomeSiteRentEnabled: boolean;
  isPMS: boolean;
  isBoomScreen: boolean;
};

export const unitsTableFeatures = (
  flags: AccountFlags
): UnitsTableFeatures => ({
  homeSiteRent: flags.isManageAmerica || flags.isHomeSiteRentEnabled,
  isPMS: flags.isPMS,
  isBoomScreen: flags.isBoomScreen
});

const COLUMN_FEATURE: Partial<Record<string, keyof UnitsTableFeatures>> = {
  home_rent_amount: "homeSiteRent",
  site_rent_amount: "homeSiteRent",
  pms_id: "isPMS",
  magic_link: "isBoomScreen",
  listed: "isBoomScreen"
};

/**
 * The Units table columns this account can see, using the same conditions as UnitsTable, so the
 * Columns menu (and its count) lists only columns that can appear in the table. Saved settings
 * for the others are kept untouched.
 */
export const availableUnitTableColumns = (
  columns: ColumnVisibilityItem[],
  features: UnitsTableFeatures
): ColumnVisibilityItem[] =>
  columns.filter((column) => {
    const feature = COLUMN_FEATURE[column.id];
    return !feature || features[feature];
  });
